var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.77366C17.799 1.77366 22.5 6.51426 22.5 12.3621C22.5 18.2099 17.799 22.9505 12 22.9505C6.20101 22.9505 1.5 18.2099 1.5 12.3621C1.5 6.51426 6.20101 1.77366 12 1.77366ZM12 4.12664C7.48967 4.12664 3.83333 7.81377 3.83333 12.3621C3.83333 16.9104 7.48967 20.5975 12 20.5975C16.5103 20.5975 20.1667 16.9104 20.1667 12.3621C20.1667 7.81377 16.5103 4.12664 12 4.12664ZM13.6505 15.8416C14.0499 15.4388 14.0499 14.7858 13.6505 14.3831L11.6464 12.3621L13.6505 10.3411C14.0499 9.93834 14.0499 9.28534 13.6505 8.88257C13.2511 8.47981 12.6035 8.47981 12.2041 8.88257L9.47682 11.6328C9.07742 12.0356 9.07742 12.6886 9.47682 13.0913L12.2041 15.8416C12.6035 16.2443 13.2511 16.2443 13.6505 15.8416Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.0c1d6561.svg";
export { ForwardRef as ReactComponent };